<template>
  <div class="aifv-box" v-if="aifvAllData && (aifvAllData.latestStageNo || `${aifvAllData.latestStageNo}` === 'null')">
    <template v-if="showRecommend">
      <recommend :recommendList="aifvAllData && aifvAllData.dtcRecommend"></recommend>
    </template>
    <template v-else-if="`${aifvAllData.latestStageNo}` === 'null' || !showRecommend">
      <div class="aifv-box-btn">
        <div class="aifv-flex-btn" :class="`${active_txt}` === '90' ? 'aifv-flex-btn2' : ''">
          <div class="btn-txt one" @click="_handleClickItems(30)">近30天</div>
          <div class="btn-txt two" @click="_handleClickItems(90)">近90天</div>
        </div>
      </div>
      <div class="aifv-cons">
        <div class="aifv-top1">
          <div class="top-txt">PVI分区诊断</div>
          <div class="canvas-div">
            <canvas id="myCanvas" class="canvas"></canvas>
            <div class="canvas-txt-info">
              <div class="info-flex info-top">
                <div class="txt-info txt1">superior</div>
                <div class="txt-info txt1">superior</div>
              </div>
              <div class="info-flex info-midd">
                <div class="txt-info txt2">anterior</div>
                <div class="txt-info txt2">posterior</div>
                <div class="txt-info txt2">anterior</div>
              </div>
              <div class="info-flex info-bottom">
                <div class="txt-info txt1">inferior</div>
                <div class="txt-info txt1">inferior</div>
              </div>
            </div>
            <div class="canvas-con canvas-con-left">
              <div class="arc-txt arc1">RSPV</div>
              <div class="arc-txt arc2">RIPV</div>
            </div>
            <div class="canvas-con canvas-con-right">
              <div class="arc-txt arc1">LSPV</div>
              <div class="arc-txt arc2">LIPV</div>
            </div>
          </div>
          <div class="canvas-btm">
            <div class="btm-txt">
              <div class="label-block label-block3"></div>
              <span class="label-txt">无问题</span>
            </div>
            <div class="btm-txt">
              <div class="label-block label-block2"></div>
              <span class="label-txt">操作时间较长(>10min)</span>
            </div>
            <div class="btm-txt">
              <div class="label-block label-block4"></div>
              <span class="label-txt">连续性问题(有6mm以上Gap)</span>
            </div>
            <div class="btm-txt">
              <div class="label-block label-block1"></div>
              <span class="label-txt">单点稳定性问题(碎点&堆叠点>30%和FOT（4g,30%）不达标点>30%）</span>
            </div>
          </div>
        </div>
        <div class="aifv-top2">
          <div class="top-txt">AIFV报告分析</div>
          <RadarChart :activeTxt="active_txt" :initData="aifvData" :titlePosition="'0'" :isNationwide="true">
          </RadarChart>
        </div>
        <div class="aifv-top3">
          <div class="top-txt">AIFV房颤手术报告</div>
          <div v-if="aifvFileData" class="list-table">
            <div class="table-tr th">
              <div class="table-th table-td table-one">季度</div>
              <div class="table-th table-td table-two">日期</div>
              <div class="table-th table-td table-three">类型</div>
              <div class="table-th table-td table-four">AIFV</div>
            </div>
            <template v-if="aifvFileData.length > 0">
              <div class="div-list-block">
                <div v-for="(item, index) in aifvFileData" :key="index" class="table-tr tr">
                  <div class="table-td table-one">{{ item.quarter }}</div>
                  <div class="table-td table-two">{{ item.operationTime }}</div>
                  <div class="table-td table-three">{{ item.operationType }}</div>
                  <div class="table-td table-four" style="cursor: pointer;" @click="handleJumpPDF(item)">
                    {{ item.operationScore }} >>
                  </div>
                </div>
              </div>
            </template>
            <div class="empty-block" v-else-if="isNone">
              <img src="@/assets/images/zone/img18.png" class="empty-img" alt="" />
              <div class="empty-txt">暂无内容</div>
            </div>
          </div>
        </div>
        <div class="aifv-box-mid" v-if="isShow && curPVIData && Object.keys(curPVIData).length > 0">
          <div class="bottom-txt top-txt">PVI优化建议</div>
          <div class="mid-flex-top" :class="curIndexFlex === 1 ? 'cur-flex' : 'cur-flex2'">
            <div v-if="aifvAllData && aifvAllData.pvi1Data" class="flex-top" @click="handleClickFlex(1)">
              <img src="@/assets/images/aifv/img04.png" class="img-flex" alt="">
              <span class="top-txt2">{{ aifvAllData.pvi1Data.modelName }}</span>
            </div>
            <div v-if="aifvAllData && aifvAllData.pvi2Data" class="flex-top" @click="handleClickFlex(2)">
              <img v-if="aifvAllData.pvi1Data" src="@/assets/images/aifv/img05.png" class="img-flex" alt="">
              <img v-else src="@/assets/images/aifv/img04.png" class="img-flex" alt="">
              <span class="top-txt2">{{ aifvAllData.pvi2Data.modelName }}</span>
            </div>
          </div>
          <div class="cover-carousel">
            <van-swipe :autoplay="3000">
              <van-swipe-item default="1" v-for="(item, index) in curPVIData.aifvImages" :key="index"
                @click="handleClickImg(curPVIData.aifvImages, index)">
                <div class="swipe-txt">{{ item.note }}</div>
                <img :src="item.url" class="carousel-img" alt="">
              </van-swipe-item>
            </van-swipe>
          </div>
          <div class="aifv-mid-left1">
            <div class="mid-left1-title">AIFV数据体现</div>
            <div class="mid-left1-txt">
              <div class="span-txt" v-html="curPVIData.dataEmbody"></div>
            </div>
            <div class="mid-left1-title mid-left1-title-top">原因分析</div>
            <div class="mid-left1-txt">
              <div class="span-txt" v-html="curPVIData.reasonAnalysis"></div>
            </div>
          </div>
          <div class="aifv-mid-left1 aifv-mid-left2">
            <div class="mid-left1-title">方法推荐</div>
            <div class="mid-left1-txt">
              <div class="span-txt" v-html="curPVIData.methodRecommend"></div>
            </div>
          </div>
        </div>
        <div class="aifv-botm-box" v-if="isShow && curPVIData && Object.keys(curPVIData).length > 0">
          <div class="botm-box2-txt">
            <span class="box2-title">内容推荐</span>
            <div class="btm-tabs">
              <span class="tabs-txt" :class="curIndexTab1 === 1 ? 'cur' : ''" @click="handleClickTab1(1)">总结</span>
              <span class="tabs-txt" :class="curIndexTab1 === 2 ? 'cur' : ''" @click="handleClickTab1(2)">内容</span>
            </div>
          </div>
          <div v-if="curIndexTab1 === 1" class="summarize">
            <div class="botm-carousel" v-if="curPVIData.images && curPVIData.images.length > 0">
              <van-swipe :autoplay="3000">
                <van-swipe-item class="vanCover" v-for="(item, index) in curPVIData.images" :key="index"
                  @click="handleClickImg(curPVIData.images, index)">
                  <img :src="item.url" class="carousel-img" alt="">
                </van-swipe-item>
              </van-swipe>
            </div>
            <div class="video-box" v-else-if="curPVIData.videoInfo">
              <div class="video-div" v-if="tab1Video" @click="handlePlayVideo">
                <img src="@/assets/images/home/bg_question1@2x.png" class="video-cover" alt="">
              </div>
              <VideoPlayerAnswer v-else ref="video" :playerVideo="curPVIData.videoInfo"></VideoPlayerAnswer>
            </div>
          </div>
          <div class="btm-list" v-else-if="curIndexTab1 === 2">
            <template v-if="curPVIRecommend && curPVIRecommend.length > 0">
              <div class="btm-item" v-for="(item, index) in curPVIRecommend" :key="index"
                @click="handleJumpRecommend(item)">
                <img :src="item.coverUrl" class="item-cover" alt="">
                <div class="item-con">
                  <div class="item-title">{{ item.title }}</div>
                  <!-- <div class="item-txt">讲师：易普</div> -->
                  <div class="item-txt">播放量:{{ item.readNum }}</div>
                  <template v-if="`${item.type}` === '2' && `${item.isUnlock}` === '1' && !item.myUnlock">
                    <div class="item-unlock">
                      <img src="@/assets/images/data-base/unlock.png" class="icon-unlock" alt="">
                      <span class="txt">{{ item.unlockCost }}积分解锁</span>
                    </div>
                  </template>
                </div>
              </div>
            </template>
            <div class="empty-block" v-else>
              <img src="@/assets/images/zone/img18.png" class="empty-img" alt="" />
              <div class="empty-txt">暂无内容</div>
            </div>
          </div>
          <div class="min-btm-txt">
            (以上分析和建议内容均基于BW专业教育团队根据过往AIFV分析经验得出,仅供阅读参考,不涉及任何对临床病例的诊断和临床手术的评价。对于任何病例的临床分析，请以医疗卫生专业人士的临床诊断为准。)
          </div>
          <div class="min-btm-txt">
            {{ curPVIData.crNo }}<br />
            {{ curPVIData.statement }}
          </div>
        </div>
        <div class="aifv-box-mid" v-if="isShow && lin1Data && Object.keys(lin1Data).length > 0">
          <div class="bottom-txt top-txt">线性消融综合分析</div>
          <div class="botm-carousel" v-if="lin1Data.aifvImages && lin1Data.aifvImages.length > 0">
            <van-swipe :autoplay="3000">
              <van-swipe-item class="vanLineCover" v-for="(item, index) in lin1Data.aifvImages" :key="index"
                @click="handleClickImg(lin1Data.aifvImages, index)">
                <div class="swipe-txt">{{ item.note }}</div>
                <img :src="item.url" class="aifv-mid-img carousel-img" alt="">
              </van-swipe-item>
            </van-swipe>
          </div>
          <div class="box-cons">
            <div class="box-cons-title">线性消融综合分析：</div>
            <div class="bg-col">
              <div class="box-cons-txt">该周期完成了：
                PVI+线#：{{ aifvAllData.pvi_count }}，RF线#：{{ aifvAllData.roof_count }}，INF线#：{{
                  aifvAllData.inf_count }}，ANT线#：{{ aifvAllData.ant_count }}，MVI线#：{{ aifvAllData.mvi_count }}，TVI线#：{{
                  aifvAllData.tvi_count }}
              </div>
              <div class="box-cons-txt">消融线的平均参数：FOT：{{ aifvAllData.avg_fot_value }}，GAP：{{ aifvAllData.avg_gap_value
                }}，手术时间（分钟）：{{ aifvAllData.avg_time_value }}</div>
              <div class="box-cons-txt">average 心房大小： {{ aifvAllData.la_apd }}</div>
            </div>
            <img src="@/assets/images/aifv/img16.png" class="icon-line" alt="">
          </div>
        </div>
        <div class="aifv-botm-box" v-if="isShow && lin1Data && Object.keys(lin1Data).length > 0">
          <div class="botm-box2-txt">
            <span class="box2-title">内容推荐</span>
            <div class="btm-tabs">
              <span class="tabs-txt" :class="curIndexTab2 === 1 ? 'cur' : ''" @click="handleClickTab2(1)">总结</span>
              <span class="tabs-txt" :class="curIndexTab2 === 2 ? 'cur' : ''" @click="handleClickTab2(2)">内容</span>
            </div>
          </div>
          <div v-if="curIndexTab2 === 1" class="summarize">
            <div class="botm-carousel" v-if="lin1Data.images && lin1Data.images.length > 0">
              <van-swipe :autoplay="3000" :height="343">
                <van-swipe-item class="vanCover" v-for="(item, index) in lin1Data.images" :key="index"
                  @click="handleClickImg(lin1Data.images, index)">
                  <img :src="item.url" class="carousel-img" alt="">
                </van-swipe-item>
              </van-swipe>
            </div>
            <div class="video-box" v-else-if="lin1Data.videoInfo">
              <div class="video-div" v-if="tab2Video" @click="handlePlayVideo2">
                <img src="@/assets/images/home/bg_question1@2x.png" class="video-cover" alt="">
              </div>
              <VideoPlayerAnswer v-else ref="video2" :playerVideo="lin1Data.videoInfo"></VideoPlayerAnswer>
            </div>
          </div>
          <div class="btm-list" v-else-if="curIndexTab2 === 2">
            <template v-if="lin1Recommend && lin1Recommend.length > 0">
              <div class="btm-item" v-for="(item, index) in lin1Recommend" :key="index"
                @click="handleJumpRecommend(item)">
                <img :src="item.coverUrl" class="item-cover" alt="">
                <div class="item-con">
                  <div class="item-title">{{ item.title }}</div>
                  <!-- <div class="item-txt">讲师：易普</div> -->
                  <div class="item-txt">播放量:{{ item.readNum }}</div>
                  <template v-if="`${item.type}` === '2' && `${item.isUnlock}` === '1' && !item.myUnlock">
                    <div class="item-unlock">
                      <img src="@/assets/images/data-base/unlock.png" class="icon-unlock" alt="">
                      <span class="txt">{{ item.unlockCost }}积分解锁</span>
                    </div>
                  </template>
                </div>
              </div>
            </template>
            <div class="empty-block" v-else>
              <img src="@/assets/images/zone/img18.png" class="empty-img" alt="" />
              <div class="empty-txt">暂无内容</div>
            </div>
          </div>
        </div>
        <div class="aifv-share-code" v-if="currentMultiCode && userInfo.memberType === 1">
          <img v-if="qrCode" class="img-code" :src="qrCode" alt="QR Code" />
        </div>
      </div>
      <!-- v-if="(userInfo.memberType && (!aifvAllData.aifvPushRecordDTO || (aifvAllData.aifvPushRecordDTO && !aifvAllData.aifvPushRecordDTO.isPush)))" -->
      <img src="@/assets/images/aifv/img15.png" v-if="userInfo.memberType" class="feedback return"
        @click="isFeedBackPush = true" alt="">
      <img src="@/assets/images/aifv/img09.png" class="feedback" @click="isFeedBack = true" alt="">
      <van-overlay :show="isFeedBackPush" @click="isFeedBackPush = false">
        <div class="wrap wrap-push" @click.stop>
          <div class="wrap-txt">提醒术者可以在本人iEP中查看</div>
          <div class="wrap-con wrap-con-push">
            <van-checkbox shape="square" checked-color="#EB1700" :plain="true"
              v-model="checkedPush">同时发送微信模版消息</van-checkbox>
            <div class="txt">因微信功能限制,iEP发送的模版信息标题为“研究报告上传成功”,请提前向hcp解释,避免引起误会。</div>
          </div>
          <div class="warp-btn">
            <div class="btn btn1" @click="isFeedBackPush = false">取消</div>
            <div class="btn btn2" @click="handleFeedBackPush()">确定</div>
          </div>
        </div>
      </van-overlay>
      <van-overlay :show="isFeedBack" @click="isFeedBack = false">
        <div class="wrap" @click.stop>
          <div class="wrap-txt">意见反馈</div>
          <div class="wrap-con">
            <van-field v-model="feedModel" autosize type="textarea" maxlength="200" placeholder="请描述您的问题~"
              show-word-limit />
          </div>
          <div class="warp-btn">
            <div class="btn btn1" @click="isFeedBack = false">取消</div>
            <div class="btn btn2" @click="handleFeedBack()">提交反馈</div>
          </div>
        </div>
      </van-overlay>
      <dialogUnlock ref="dialogUnlock" @unlockSuccess="handleJump" :dataProps="dataProps"></dialogUnlock>
      <div class="custom-mask" @click="hidePreviewIfMaskClicked">
        <van-image-preview ref="imagePreview" v-model="showPreview" :images="images" :closeable="true" :start-position="initialIndex" />
      </div>
    </template>
  </div>
</template>

<script>
import { getAifvInfo, getAIFVFileList, aifvPushRecord } from '@/api/aifv'
import RadarChart from '@/components/RadarChart.vue'
import VideoPlayerAnswer from '../home/components/VideoPlayerAnswer.vue'
import { setSha, traceClickURL } from '@/utils/util'
import { sendFeedback, updateIsRead } from '@/api/api'
import recommend from './recommend.vue'
import withRouteTracking from '@/utils/withRouteTracking'
import qrcode from 'qrcode-generator'
import {isScorm} from '../../api/scorm'

const UserProfile = {
  name: 'AIFV',
  components: {
    RadarChart,
    VideoPlayerAnswer,
    recommend
  },
  data () {
    return {
      aifvData: {
        prevAifv: {
          aifv1: 0,
          aifv2: 0,
          aifv3: 0,
          aifv4: 0,
          aifv5: 0,
          aifv6: 0
        },
        currentAifv: {
          aifv1: 0,
          aifv2: 0,
          aifv3: 0,
          aifv4: 0,
          aifv5: 0,
          aifv6: 0
        },
        countryAvgAifv: {
          aifv1: 0,
          aifv2: 0,
          aifv3: 0,
          aifv4: 0,
          aifv5: 0,
          aifv6: 0
        }
      },
      aifvFileData: [],
      isNone: false,
      aifvAllData: {},
      aifvColors: ['#53CE76', '#EC3636', '#FBE058', '#0F68B2'],
      curIndexFlex: 1,
      curPVIData: {},
      curPVIRecommend: [],
      curIndexTab1: 1,
      curIndexTab2: 1,
      tab1Video: true,
      lin1Data: {},
      lin1Recommend: [],
      tab2Video: true,
      isFeedBack: false,
      feedModel: '',
      isFeedBackPush: false,
      checkedPush: false,
      dataProps: {
        unlockContent: '兑换EP公开课课程',
        unlockTxt: '课程'
      },
      showPreview: false,
      images: [],
      initialIndex: 0,
      isDragging: false,
      dragStartX: 0,
      active_txt: '90',
      qrCode: null,
    }
  },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    },
    currentMultiCode () {
      return this.$route.query.aifvMultiCode || this.userInfo.multiCode
    },
    isShow () {
      return (this.aifvAllData.aifvPushRecordDTO && this.aifvAllData.aifvPushRecordDTO.isPush) || this.userInfo.memberType
    },
    showRecommend () {
      return (this.aifvAllData && this.aifvAllData.latestStageNo && this.aifvAllData.latestStageNo.indexOf('D') > -1 && this.aifvAllData.id === null) && this.activeTxt === '90'
    }
  },
  methods: {
    _handleClickItems (_txt) {
      if (this.active_txt === `${_txt}`) return
      this.active_txt = `${_txt}`
      this.handleAifvFun()
    },
    handleMouseDown (event) {
      if (!this.showPreview || event.buttons !== 1) return // 只处理左键按下
      // 开始拖动
      this.isDragging = true
      this.dragStartX = event.clientX
      // 添加鼠标移动和释放的监听器
      document.addEventListener('mousemove', this.handleMouseMove)
      document.addEventListener('mouseup', this.handleMouseUp)
    },
    handleMouseMove (event) {
      if (!this.isDragging) return
      // 计算拖动距离
      this.deltaX = event.clientX - this.dragStartX
      // 重置起点
      // this.dragStartX = event.clientX
    },
    handleMouseUp () {
      if (!this.isDragging) return
      // 根据拖动方向切换图片
      if (this.deltaX > 50 && this.initialIndex > 0) {
        this.initialIndex--
      } else if (this.deltaX < -50 && this.initialIndex < this.images.length - 1) {
        this.initialIndex++
      }
      // 结束拖动
      this.isDragging = false
      // 移除鼠标移动和释放的监听器
      document.removeEventListener('mousemove', this.handleMouseMove)
      document.removeEventListener('mouseup', this.handleMouseUp)
    },
    // 点击关闭
    hidePreviewIfMaskClicked (event) {
      // 判断点击是否发生在预览图片本身之外
      if (event.target.classList.contains('van-image-preview__swipe-item')) {
        this.showPreview = false
        document.removeEventListener('mousedown', this.handleMouseDown)
      }
    },
    // 点击放大图片
    handleClickImg (dataArr, index) {
      this.images = []
      this.images = dataArr.map(res => res.url)
      this.initialIndex = index
      this.showPreview = true
      document.addEventListener('mousedown', this.handleMouseDown)
    },
    handleClickTab1 (index) {
      if (this.curIndexTab1 === index) return
      this.curIndexTab1 = index
    },
    handleClickTab2 (index) {
      if (this.curIndexTab2 === index) return
      this.curIndexTab2 = index
    },
    handlePlayVideo () {
      this.tab1Video = false
      setTimeout(() => {
        this.$refs.video.player.play()
      })
    },
    handlePlayVideo2 () {
      this.tab2Video = false
      setTimeout(() => {
        this.$refs.video2.player.play()
      })
    },
    handleClickFlex (index) {
      if (this.aifvAllData.pvi1Data && this.aifvAllData.pvi2Data) {
        if (this.curIndexFlex === index) return
        this.curIndexFlex = index
        if (this.curIndexFlex === 1) {
          this.curPVIData = this.aifvAllData.pvi1Data
          this.curPVIRecommend = this.aifvAllData.pvi1DataRecommend ? this.aifvAllData.pvi1DataRecommend : []
        } else if (this.curIndexFlex === 2) {
          this.curPVIData = this.aifvAllData.pvi2Data
          this.curPVIRecommend = this.aifvAllData.pvi2DataRecommend ? this.aifvAllData.pvi2DataRecommend : []
        }
      }
    },
    getAIFVFileData () {
      if (!this.currentMultiCode) {
        this.isNone = true
        return
      }
      let params = {
        multiCode: this.currentMultiCode,
        pageSize: 500,
      }
      getAIFVFileList(params).then(res => {
        if (res && res.data) {
          if (res.data.list && res.data.list.length > 0) {
            this.aifvFileData = JSON.parse(JSON.stringify(res.data.list))
            this.aifvFileData.forEach(item => {
              item.createTime = this.$moment(parseInt(item.createTime)).format('YYYY-MM-DD')
              item.operationTime = this.$moment(parseInt(item.operationTime)).format('YYYY-MM-DD')
              item.updateTime = this.$moment(parseInt(item.updateTime)).format('YYYY-MM-DD')
            })
          } else {
            this.isNone = true
          }
        }
      })
        .catch(err => {
          console.log('getAIFVFileList error', err)
        })
    },
    generateQRCode () {
      if (this.currentMultiCode && this.userInfo.memberType === 1) {
        // 创建二维码
        const typeNumber = 8 // QR Code 版本
        const errorCorrectionLevel = 'L' // 错误校正等级，可选 L M Q H
        const qr = qrcode(typeNumber, errorCorrectionLevel)
        console.log(qr, '=-')
        qr.addData(`${process.env.baseURL}/evaluateonepage?aifvMulticode=${this.currentMultiCode}&employeeId=${this.userInfo.id}`)
        qr.make()
        // 获取二维码图片
        this.qrCode = qr.createDataURL(4) // 4 是缩放比例
        console.log(this.qrCode)
      }
    },
    handleCanvas () {
      const canvas = document.getElementById('myCanvas')
      const ctx = canvas.getContext('2d')
      canvas.width = canvas.clientWidth
      canvas.height = canvas.clientHeight
      const centerXLeft = canvas.width / 4
      const centerXRight = (canvas.width * 3) / 4
      const centerY = canvas.height / 2
      const outerRadiusX = canvas.width / 7.4
      const outerRadiusY = canvas.width / 3.4 // 垂直半径，使圆变成椭圆
      const dotRadius = canvas.width / 40
      function drawCircleAndDots (centerX, offsetAngle, colors) {
        const numDots = 36
        const angleStep = (Math.PI * 2) / numDots
        // Draw the ellipse
        ctx.beginPath()
        ctx.ellipse(centerX, centerY, outerRadiusX, outerRadiusY, 0, 0, Math.PI * 2)

        // Draw the dots
        for (let i = 0; i < numDots; i++) {
          const angle = offsetAngle + i * angleStep // Math.atan(outerRadiusX / outerRadiusY) * (180 / Math.PI)
          const x = centerX + outerRadiusX * Math.cos(angle)
          const y = centerY + outerRadiusY * Math.sin(angle)
          ctx.beginPath()
          ctx.arc(x, y, dotRadius, 0, Math.PI * 2)

          // Determine the color based on the angle
          const normalizedAngle = (angle + Math.PI) % (Math.PI * 2)
          let quadrant
          if (normalizedAngle >= 0 && normalizedAngle < Math.PI * 0.2) {
            quadrant = 0
          } else if (normalizedAngle >= Math.PI * 0.2 && normalizedAngle < Math.PI * 0.8) {
            quadrant = 1
          } else if (normalizedAngle >= Math.PI * 0.8 && normalizedAngle < Math.PI * 1.2) {
            quadrant = 2
          } else if (normalizedAngle >= Math.PI * 1.2 && normalizedAngle < Math.PI * 1.8) {
            quadrant = 3
          } else {
            quadrant = 0
          }
          ctx.fillStyle = colors[quadrant] ? colors[quadrant] : '#DFE0E3'
          ctx.fill()
        }
        ctx.beginPath()
        ctx.moveTo(centerX - outerRadiusY + canvas.width / 14, centerY - outerRadiusY)
        ctx.lineTo(centerX + outerRadiusY - canvas.width / 14, centerY + outerRadiusY)
        ctx.moveTo(centerX + outerRadiusY - canvas.width / 14, centerY - outerRadiusY)
        ctx.lineTo(centerX - outerRadiusY + canvas.width / 14, centerY + outerRadiusY)
        ctx.strokeStyle = '#EB1700'
        ctx.stroke()
      }

      // Define colors for each quadrant
      const quadrantColors = [this.aifvColors[this.aifvAllData.rpv_ant], this.aifvColors[this.aifvAllData.rpv_rf], this.aifvColors[this.aifvAllData.rpv_pst], this.aifvColors[this.aifvAllData.rpv_inf]]
      const quadrantColors2 = [this.aifvColors[this.aifvAllData.lpv_pst], this.aifvColors[this.aifvAllData.lpv_rf], this.aifvColors[this.aifvAllData.lpv_ant], this.aifvColors[this.aifvAllData.lpv_inf]]

      // Draw left circle with different colored dots and diagonal cross lines
      drawCircleAndDots(centerXLeft, 0, quadrantColors)

      // Draw right circle with different colored dots and diagonal cross lines
      drawCircleAndDots(centerXRight, Math.PI, quadrantColors2)
    },
    // 是否需要推荐
    handleFeedBackPush () {
      let modelNameObj = this.aifvAllData.pvi1Data ? this.aifvAllData.pvi1Data : this.aifvAllData.pvi2Data
      let parmas = {
        'multiCode': this.currentMultiCode,
        'userId': this.userInfo.id,
        'isPush': this.checkedPush ? 1 : 0,
        'modelName': (modelNameObj && modelNameObj.modelName) ? modelNameObj.modelName : '',
      }
      aifvPushRecord(parmas).then(res => {
        if (res.code === 0) {
          this.isFeedBackPush = false
          this.handleAifvFun()
          this.$toast(this.checkedPush ? '发送至术者iEP并且推送到微信模板消息成功' : '发送至术者iEP成功')
        } else {
          this.$toast(res.msg)
        }
      })
    },
    handleFeedBack () {
      if (!this.feedModel) {
        this.$toast('请先输入内容再提交！')
        return
      }
      // type、反馈类型1系统反馈意见2推荐反馈意见3每日答题反馈意见
      let params = {
        type: 4,
        baseId: '',
        baseTitle: this.currentMultiCode,
        content: this.feedModel,
        state: 2,
        userName: this.userInfo.realName,
        userId: this.userInfo.id,
        role: this.userInfo.roles[0],
        phone: this.userInfo.phone,
        email: this.userInfo.email,
        openId: this.userInfo.iepOpenId
      }
      sendFeedback(params).then(res => {
        if (res.code === 0) {
          this.feedModel = ''
          this.isFeedBack = false
          this.$toast('反馈成功')
        } else {
          this.$toast(res.msg)
        }
      })
    },
    handleJumpPDF (item) {
      updateIsRead({
        operationId: item.id
      }).then(res => {
        this.$router.push({
          path: '/pdfView',
          query: {
            code: item.fileId,
            id: item.id
          }
        })
      })
    },

    handleJumpRecommend (item) {
      this.dataDetails = item
      if (`${item.isUnlock}` === '1' && !item.myUnlock) {
        this.dataProps.baseId = item.baseId
        this.dataProps.unlockCost = item.unlockCost
        this.$refs.dialogUnlock.dailogShow = true
        return
      }
      this.handleJump()
    },
    async handleJump () {
      sessionStorage.setItem('entrance', '57')
      let item = this.dataDetails
      // let openid = `&unionid=${this.userInfo.unionId}&openid=${this.userInfo.iepOpenId}${setSha(`xxbiep${this.userInfo.iepOpenId}`)}`
      let trackParams = `&entrance=57&businessChannel=57`
      let openidBindli = `&unionid=${this.userInfo.unionId}&openid=${this.userInfo.iepOpenId}${setSha(`xxbiep${this.userInfo.iepOpenId}`)}`
      // let iepTxt = `&nickname=123&avatar=123&subscribe=1`
      if (item.type === 1) {
        this.$router.push({
          path: '/articleDetails',
          query: {
            id: item.baseId,
            entrance: 57,
            channel: 57,
          }
        })
        // setTimeout(() => { traceClickURL() })
        // window.location.href = `${process.env.iepUrl}/mobile/home/article-detail?index=0&id=${item.baseId}${openid}${iepTxt}${trackParams}`
      } else if (item.type === 3) {
        setTimeout(() => { traceClickURL() })
        window.location.href = `${process.env.bingliUrl}/wap/index.html#/casedetails?id=${item.baseId}${openidBindli}${trackParams}`
      } else if (item.type === 2) {
        const query = {
          courseId: item.baseId,
          sectionId: item.sectionId,
          entrance: '57',
          channel: '57'
        }
        const isscorm = await isScorm(item.baseId)
        let path = '/courserDetails'
        if (isscorm.data) {
          path = '/scormCourseDetail'
        }
        this.$router.push({path, query})
      }
    },
    handleAifvFun () {
      let multiCode = this.currentMultiCode // 'MULD100000977' //
      if (!multiCode && this.$route.query.SCANQACODE) {
        this.$toast('需有AIFV数据才能开通该模块，已为您跳转至iEP首页')
        setTimeout(() => {
          this.$router.push({
            path: '/home'
          })
        }, 3000)
        return
      }
      let params = {
        multiCode,
        dateRange: this.active_txt === '30' ? '30D' : '90D'
      }
      if (this.$route.query.isMessage) {
        params.ismessage = 1
      } else {
        params.ismessage = 2
      }
      getAifvInfo(params).then(res => {
        if (!res.data.id && this.active_txt === '30') {
          this.$toast('该时间维度暂无数据')
        }
        this.aifvAllData = res.data
        if (!res.data) return
        if (this.showRecommend) return
        if (!res.data.id && (res.data.dtcRecommend === null || (res.data.dtcRecommend && res.data.dtcRecommend.length === 0)) && this.$route.query.SCANQACODE && this.active_txt === '90') {
          this.$toast('需有AIFV数据才能开通该模块，已为您跳转至iEP首页')
          setTimeout(() => {
            this.$router.push({
              path: '/home'
            })
          }, 3000)
          return
        }
        this.aifvData.prevAifv = {
          aifv1: res.data.mean_gap_l,
          aifv2: res.data.mean_bp_stack_l,
          aifv3: res.data.mean_time_l,
          aifv4: res.data.mean_fot_l,
          aifv5: res.data.mean_rf_l,
          aifv6: res.data.mean_effectivetimerate_l
        }
        this.aifvData.currentAifv = {
          aifv1: res.data.mean_gap,
          aifv2: res.data.mean_bp_stack,
          aifv3: res.data.mean_time,
          aifv4: res.data.mean_fot,
          aifv5: res.data.mean_rf,
          aifv6: res.data.mean_effectivetimerate
        }
        this.aifvData.countryAvgAifv = {
          aifv1: res.data.meanGapFull,
          aifv2: res.data.meanBpStackFull,
          aifv3: res.data.meanTimeFull,
          aifv4: res.data.meanFotFull,
          aifv5: res.data.meanRfFull,
          aifv6: res.data.meanEffectivetimerateFull
        }
        this.curPVIData = res.data.pvi1Data ? res.data.pvi1Data : res.data.pvi2Data
        this.curPVIRecommend = res.data.pvi1DataRecommend ? res.data.pvi1DataRecommend : res.data.pvi2DataRecommend
        this.lin1Data = res.data.lin1Data
        this.lin1Recommend = res.data.lin1Recommend ? res.data.lin1Recommend : []
        this.$nextTick(() => {
          this.handleCanvas()
          this.generateQRCode()
        })
      })
    }
  },
  mounted () {
    this.handleAifvFun()
    this.getAIFVFileData()
  }
}
export default withRouteTracking(UserProfile)
</script>

<style lang='less' scoped>
.aifv-box {
  position: relative;
  min-height: 100vh;
  background-color: rgba(235, 23, 0, 0.11);
  width: 375px;
  overflow-x: hidden;

  .aifv-box-btn {
    position: relative;
    display: flex;
    align-content: center;
    justify-content: center;
    padding: 10px;
    box-sizing: border-box;

    .aifv-flex-btn {
      background-image: url('../../assets/images/aifv/img20.png');
      width: 213px;
      height: 60px;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      display: flex;
      align-content: center;
      justify-content: center;

      &.aifv-flex-btn2 {
        background-image: url('../../assets/images/aifv/img21.png');

        .two {
          color: #fff;
        }

        .one {
          color: #000;
        }
      }

      .btn-txt {
        color: #000;
        width: 106px;
        text-align: center;
        height: 60px;
        line-height: 60px;
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 600;
        font-size: 14px;
      }

      .one {
        color: #fff;
      }
    }
  }

  .aifv-cons {
    padding: 17px 20px;
    padding-top: 0;
    box-sizing: border-box;
    position: relative;
    width: 375px;
    overflow-x: hidden;

    .top-txt {
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 600;
      font-size: 16px;
      color: #000000;
      padding: 16px;
      box-sizing: border-box;
    }

    .aifv-top1 {
      background: #fff;
      border: 1px solid #FFFFFF;
      border-radius: 8px 8px 0 0;

      .top-txt {
        border-bottom: 1px solid #FFFFFF;
        height: 47px;
        padding-left: 22px;
        padding-top: 15px;
        font-size: 18px;
        color: #EB1700;
        font-weight: 600;
        line-height: 26px;
        position: relative;
        box-sizing: border-box;

        &::before {
          position: absolute;
          content: "";
          width: 4px;
          height: 14px;
          left: 11px;
          top: 20px;
          background-color: #EB1700;
        }
      }

      .canvas-btm {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        position: relative;
        top: -12px;

        .btm-txt {
          display: flex;
          margin-bottom: 10px;
          width: 100%;
          padding-left: 20px;
          box-sizing: border-box;

          .label-block {
            width: 24px;
            min-width: 24px;
            height: 15px;
            border-radius: 4px;
            margin-right: 4px;

            &.label-block1 {
              background-color: #EC3636;
            }

            &.label-block2 {
              background-color: #0F68B2;
            }

            &.label-block3 {
              background-color: #53CE76;
            }

            &.label-block4 {
              background-color: #FBE058;
            }
          }

          .label-txt {
            font-size: 14px;
            color: #5B5F6A;
            font-family: Inter, Inter;
            line-height: 16px;
          }
        }
      }

      .canvas-div {
        position: relative;

        .canvas {
          position: relative;
          width: 280px;
          height: 280px;
          left: 28px;
        }

        .info-flex {
          display: flex;
          align-items: center;
          justify-content: space-between;
          position: absolute;

          &.info-top {
            top: 20px;
            left: 28px;
            width: 280px;

            .txt-info {
              font-size: 14px;
            }
          }

          &.info-bottom {
            top: 234px;
            left: 28px;
            width: 280px;

            .txt-info {
              font-size: 14px;
            }
          }

          &.info-midd {
            width: 326px;
            top: 130px;
            left: 6px;
          }

          .txt-info {
            font-size: 12px;
            color: #6A7481;
            font-family: Inter, Inter;

            &.txt1 {
              flex: 1;
              text-align: center;
            }
          }
        }
      }

      .canvas-con {
        position: absolute;
        top: 82px;

        &.canvas-con-left {
          left: 78px;
        }

        &.canvas-con-right {
          right: 76px;
        }

        .arc-txt {
          width: 39px;
          height: 39px;
          border: 2px solid #EB1700;
          border-radius: 50%;
          font-size: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #EB1700;
          box-shadow: 0px 0px 16px 0px rgba(255, 91, 12, 0.25);
          background-color: #Fff;
          margin-bottom: 38px;
          box-sizing: border-box;
        }
      }
    }

    .aifv-top2 {
      border-top: 1px solid #E0E6F7;
      background-color: #fff;
    }

    .aifv-top3 {
      border-top: 1px solid #E0E6F7;
      background-color: #fff;

      .list-table {
        background-color: #fff;
        width: 100%;
        padding: 0 8px;
        padding-bottom: 10px;
        box-sizing: border-box;

        .tilte-txt {
          display: flex;
          align-items: center;
          font-size: 12px;
          color: #2b2b2b;
          font-weight: 600;
          height: 60px;

          .num {
            font-size: 22px;
            color: #2b2b2b;
            font-weight: bold;
            margin-left: 10px;
          }
        }

        .div-list-block {
          max-height: 160px;
          overflow-y: auto;
        }

        .table-tr {
          display: flex;
          align-items: center;
          height: 32px;
          padding: 0 10px;
          box-sizing: border-box;
          margin-bottom: 12px;
          justify-content: space-between;

          &.th {
            background-color: #fff;
            margin-bottom: 0;
          }

          &.tr {
            height: 48px;
            line-height: 14px;
            margin-bottom: 16px;
            background-color: #F5F7FC;
            margin-bottom: 6px;
            border-radius: 8px;
          }

          .table-td {
            font-size: 14px;
            color: #2b2b2b;
            font-weight: 400;
            width: 25%;

            &.table-one {
              width: 50px;
            }

            &.table-two {
              width: 95px;
            }

            &.table-three {
              width: 105px;
            }

            &.table-four {
              flex: 1;
              text-align: center;
            }

            &.table-th {
              font-size: 14px;
              color: #6A7481;
            }
          }
        }
      }
    }

    .aifv-box-mid {
      margin-top: 16px;
      background-color: #fff;
      border-radius: 8px;
      padding-bottom: 15px;
      box-sizing: border-box;

      .bottom-txt {
        background-image: url('../../assets/images/aifv/img08.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
        height: 50px;
        width: 100%;
        color: #EB1700;
      }

      .mid-flex-top {
        display: flex;
        align-items: center;
        height: 57px;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        position: relative;

        &.cur-flex {
          background-image: url('../../assets/images/aifv/img06.png');
        }

        &.cur-flex2 {
          background-image: url('../../assets/images/aifv/img07.png');
        }

        .flex-top {
          display: flex;
          flex: 1;
          padding-left: 10px;
          box-sizing: border-box;

          .img-flex {
            width: 44px;
            height: 22px;
            margin-right: 1px;
          }

          .top-txt2 {
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 600;
            font-size: 13px;
            color: #000000;
            width: 100px;
          }
        }
      }

      .aifv-mid-img {
        // width: 314px;
        // height: 222px;
        // margin-left: 50%;
        // margin-top: 14px;
        // margin-bottom: 14px;
        // transform: translateX(-50%);
      }

      .box-cons {
        background: linear-gradient(180deg, rgba(255, 148, 28, 0.1) 0%, rgba(255, 148, 28, 0.05) 100%);
        border: 1px solid #FF941C;
        border-radius: 8px;
        padding: 2px;
        box-sizing: border-box;
        width: 314px;
        margin-left: 50%;
        transform: translateX(-50%);
        margin-top: 14px;
        position: relative;

        .icon-line {
          position: absolute;
          width: 40px;
          bottom: 12px;
          right: 15px;
        }

        .box-cons-title {
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 600;
          font-size: 16px;
          color: #000000;
          line-height: 22px;
          padding-bottom: 15px;
          padding-top: 12px;
          padding-left: 15px;
          box-sizing: border-box;
        }

        .bg-col {
          padding: 12px 0;
          box-sizing: border-box;
          border-radius: 4px;

          .box-cons-txt {
            padding-left: 21px;
            position: relative;
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-size: 14px;
            color: #5B5F6A;
            line-height: 20px;
            margin-bottom: 9px;

            &::before {
              position: absolute;
              width: 4px;
              height: 4px;
              border-radius: 50%;
              background: #5B5F6A;
              top: 6px;
              left: 13px;
              content: "";
            }
          }
        }
      }
    }

    .aifv-mid-left1 {
      width: 292px;
      background-image: url("../../assets/images/aifv/img02.png");
      background-size: 100% 100%;
      background-position: bottom;
      background-repeat: no-repeat;
      margin: 0 auto;
      padding: 10px 16px;
      padding-bottom: 2px;
      box-sizing: border-box;
      position: relative;
      overflow: hidden;
      border-radius: 8px;
      margin-top: 30px;

      /**&::before {
        position: absolute;
        content: "";
        width: 100%;
        height: 100%;
        background-image: url("../../assets/images/aifv/img02.png");
        background-repeat: no-repeat;
        background-size: 100%;
        left: 0;
        top: 0;
      }*/

      &.aifv-mid-left2 {
        width: 292px;
        background-image: url("../../assets/images/aifv/img03.png");

        /**&::before {
          background-image: url("../../assets/images/aifv/img03.png");
        }*/
      }

      .mid-left1-title {
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 600;
        font-size: 16px;
        color: #000000;
        line-height: 22px;
        margin-bottom: 6px;
      }

      .span-txt {
        display: block;
        font-size: 14px;
        color: #5B5F6A;
        font-family: Source Han Sans CN, Source Han Sans CN;
        line-height: 20px;
        padding-left: 8px;
        position: relative;
        margin-bottom: 8px;

        &::before {
          position: absolute;
          width: 4px;
          height: 4px;
          border-radius: 50%;
          background: #5B5F6A;
          top: 6px;
          left: 0;
          content: "";
        }
      }
    }

    .aifv-botm-box {
      margin-top: 3px;
      background-color: #fff;
      padding: 0 10px;
      box-sizing: border-box;
      padding-bottom: 12px;

      .video-div {
        .video-cover {
          width: 100%;
          height: 200px;
          object-fit: contain;
          display: block;
        }
      }

      .botm-box2-txt {
        display: flex;
        align-items: center;
        height: 46px;
        padding: 0 6px;
        box-sizing: border-box;

        .box2-title {
          color: #EB1700;
          font-size: 16px;
          font-weight: 600;
          position: relative;
          margin-right: 34px;

          &::after {
            position: absolute;
            right: -18px;
            top: 50%;
            transform: translateY(-50%);
            content: "";
            background-color: #EB1700;
            width: 4px;
            height: 14px;
          }
        }

        .btm-tabs {
          height: 45px;
          display: flex;
          align-items: center;

          .tabs-txt {
            font-size: 16px;
            color: #000000;
            font-weight: 600;
            width: 40px;
            cursor: pointer;
            display: flex;
            justify-content: center;
            align-items: center;

            &.cur {
              position: relative;

              &::after {
                position: absolute;
                width: 75%;
                height: 2.5px;
                content: "";
                background: #EB1700;
                left: 50%;
                transform: translateX(-50%);
                bottom: -2px;
              }
            }
          }
        }
      }

      .btm-list {
        .btm-item {
          display: flex;
          margin-bottom: 14px;

          .item-con {
            width: 180px;
          }

          .item-cover {
            width: 114px;
            height: 65px;
            border-radius: 6px;
            margin-right: 13px;
          }

          .item-con {
            overflow: hidden;
            .item-title {
              font-size: 16px;
              color: #333333;
              font-weight: 800;
              line-height: 22px;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              margin-bottom: 4px;
            }

            .item-txt {
              font-size: 13px;
              color: #B1B1B1;
              line-height: 20px;
            }
          }
        }
      }

      .min-btm-txt {
        background-color: #F5F7FC;
        padding: 8px 10px;
        box-sizing: border-box;
        border-radius: 4px;
        margin-top: 8px;
        font-size: 10px;
        color: #6A7481;
        line-height: 16px;
      }
    }

    .aifv-share-code {
      width: 100%;
      height: 282px;
      background-image: url('../../assets/images/aifv/img24.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 18px;

      .img-code {
        width: 116px;
        height: 116px;
        display: block;
        margin-top: 16px;
        border-radius: 10px;
      }
    }
  }
}

.feedback {
  width: 52px;
  height: 52px;
  position: fixed;
  right: 12px;
  bottom: 52px;
  z-index: 999;

  &.return {
    bottom: 120px;
  }
}

/deep/ .van-swipe-item {
  position: static;
  height: 190px !important;

  .swipe-txt {
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 500;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.8);
    line-height: 20px;
    text-align: center;
    margin-top: 9px;
  }

  &.vanCover {
    height: 343px !important;

    .carousel-img {
      height: 343px;
    }
  }

  &.vanLineCover {
    height: 222px !important;

    .aifv-mid-img {
      height: 222px;
    }
  }

  .carousel-img {
    display: block;
    width: 100%;
    height: 180px;
    object-fit: contain;
  }

}
/deep/ .van-swipe__indicators {
  bottom: 0 !important;
}

/deep/ .van-swipe__indicator {
  width: 16px;
  height: 4px;
  border-radius: 10px;
  background-color: #D9D9D9;
  opacity: 1;

  &.van-swipe__indicator--active {
    background-color: #EB1700;
  }
}

.empty-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 20px;
  padding-bottom: 20px;

  .empty-img {
    width: 185px;
    display: block;
    margin-bottom: 4px;
  }

  .empty-txt {
    font-size: 12px;
    color: #949ba5;
    text-align: center;
  }
}

/deep/ .van-overlay {
  z-index: 9999;

  .wrap {
    width: 320px;
    border-radius: 10px;
    background: #fff;
    padding: 20px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    box-sizing: border-box;

    &.wrap-push {
      width: 320px;

      .wrap-txt {
        margin-bottom: 25px;
      }
    }

    .img-wrap {
      width: 80px;
      display: block;
      margin-bottom: 18px;
      margin-left: 50%;
      transform: translateX(-50%);
    }

    .wrap-txt {
      font-size: 17px;
      font-weight: 600;
      color: #000000;
      text-align: center;
      font-family: Source Han Sans CN, Source Han Sans CN;
      line-height: 20px;
      width: 100%;
      margin-bottom: 10px;

      &.wrap-txt2 {
        border-bottom: 1px solid #A9AEB6;
        padding-bottom: 10px;
        box-sizing: border-box;
        text-align: left;
        margin-bottom: 14px;
      }
    }

    .wrap-txt3 {
      position: relative;

      &::before {
        content: '*';
        font-size: 17px;
        color: #FF0000;
        width: 9px;
        text-align: center;
        display: inline-block;
      }
    }

    .wrap-con {
      width: 288px;
      height: 120px;
      margin-left: 50%;
      transform: translateX(-50%);
      color: #666;
      font-size: 16px;
      overflow: hidden;
      background: #F9F8F7;
      border-radius: 8px;
      margin-bottom: 10px;

      &.wrap-con-push {
        background-image: none;
        width: 260px;
        height: auto;
        margin-bottom: 25px;
        padding: 10px;

        /deep/ .van-checkbox__icon {
          border-radius: 4px;
          overflow: hidden;
        }

        /deep/ .van-checkbox__label {
          color: rgba(0, 0, 0, 0.80);
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 500;
          font-size: 16px;
          line-height: 20px;
        }

        .txt {
          color: rgba(0, 0, 0, 0.50);
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-size: 14px;
          margin-top: 20px;
        }
      }

      .van-cell {
        background: rgba(0, 0, 0, 0.02);
        height: 120px;
      }

      .href-txt {
        color: #EB1700;
      }

      .van-field__value {
        overflow-y: auto;

        .van-field__control {
          height: 80px !important;
          line-height: 22px;
          font-size: 16px;
          color: #333;

          &::placeholder {
            color: rgba(0, 0, 0, 0.40);
          }
        }
      }
    }

    .warp-btn {
      display: grid;
      grid-template-columns: 1fr 1fr;
      column-gap: 8px;
      box-sizing: border-box;

      .btn {
        text-align: center;
        font-size: 17px;
        font-weight: 500;
        border-radius: 30pc;
        height: 42px;
        line-height: 42px;

        &.btn1 {
          color: #81766F;
          background: #F1EFED;
        }

        &.btn2 {
          background: #EB1700;
          color: #fff;
        }
      }
    }
  }
}

.item-unlock {
  display: flex;
  align-items: center;
  height: 20px;
  margin-top: 2px;

  .icon-unlock {
    width: 10px;
    margin-right: 4px;
    display: block;
  }

  .txt {
    color: #EB1700;
    font-size: 12px;
  }
}

/deep/ .van-image-preview__swipe-item {
  height: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/views/AIFV/AIFV.vue